module.exports = __webpack_public_path__ + "static/media/2process-working.e584b045.png";